function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconHelpRexFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M16 2a14 14 0 100 28 14 14 0 000-28zm-1.64 16.23v-.69a3.72 3.72 0 01.41-1.74 5 5 0 011.58-1.61 5.1 5.1 0 001.17-1.06 1.65 1.65 0 00.3-1 1.179 1.179 0 00-.49-1 2.14 2.14 0 00-1.33-.31 3.09 3.09 0 00-1.77.52 5.28 5.28 0 00-1.32 1.26l-1.52-2.45a7.251 7.251 0 012.06-1.55 6.53 6.53 0 012.9-.6 5.77 5.77 0 012.49.51 4.29 4.29 0 011.69 1.41 3.7 3.7 0 01.6 2.1 3.51 3.51 0 01-.55 2A5.999 5.999 0 0119 15.6a4.279 4.279 0 00-1.12 1.08 2 2 0 00-.26 1v.58l-3.26-.03zM16 24a2.1 2.1 0 01-1.53-.61 2 2 0 01-.64-1.51 2.001 2.001 0 01.64-1.52 2.149 2.149 0 011.53-.61 2.18 2.18 0 011.55.61 2 2 0 01.64 1.52 2 2 0 01-.64 1.51A2.13 2.13 0 0116 24z",
    fill: props.color
  }));
}

export default SvgIconHelpRexFilled;